module.exports = __webpack_public_path__ + "img/b.dfa96054.jpg";